import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Has SPN field definition
 * Boolean field with Yes/No dropdown for SPN presence filtering
 */
export const ADObjectHasSPN = createBooleanSimpleFilterDefinition(
  'hasspn',
  'Has SPN'
);
